import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Loading } from "../../components/loading";
import { Navmenu } from "../../components/navmenu";
import { RecordsPanel } from "../../components/records-panel";
import { Record } from "../../components/record";

import { getRecipesRequest } from "../../store/recipes/actions";
import { filterRecords } from "../../utils/filter-records";

export const Recipes = () => {
    const dispatch = useDispatch();
    const [searchValue, setSearchValue] = useState("");
    useEffect(() => {
        dispatch(getRecipesRequest());
    }, [dispatch]);

    const { recipes, isLoading } = useSelector((state) => state.recipes);

    const filteredRecords = filterRecords(recipes, searchValue, [
        "name",
        "type",
    ]);

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div className="page">
                    <Navmenu />
                    <main className="main">
                        <RecordsPanel
                            searchValue={searchValue}
                            setSearchValue={setSearchValue}
                            link="/recipe/create"
                        />
                        {filteredRecords ? (
                            filteredRecords.map((recipe, idx) => (
                                <Record
                                    title={recipe.name}
                                    subtitle={recipe.type}
                                    id={recipe.id}
                                    link="recipe"
                                    url={recipe.url}
                                    key={idx.toString()}
                                />
                            ))
                        ) : (
                            <p className="not__found">Records not found...</p>
                        )}
                    </main>
                </div>
            )}
        </>
    );
};
